import React from "react";
import {SvgIcon, SvgIconProps} from "@mui/material";

const JadeLizardSvg = (props: any) => (<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <path d="M1.02066 1V33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1 18.0226H32.9856" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M33 15.4974H25.6674L22.5423 13.9516H16.2837L12.2675 18.0176" stroke="#089981" strokeWidth="2"/>
        <path d="M1.26226 29.1128L12.2675 18.0176" stroke="#A40C0C" strokeWidth="2"/>
    </svg>
)


const JadeLizard: React.FC<SvgIconProps> = React.memo((props) => (
    <SvgIcon {...props}>
        {JadeLizardSvg(props)}
    </SvgIcon>
));
export default JadeLizard